<template>
  <a-table class="stripped table-hover" :columns="columns" :data-source="data" :row-selection="rowSelection"
    :pagination="false">
    <template #bodyCell="{ column, record }">
      <!-- <template v-if="column.key === 'Star'">
        <div class="d-flex align-items-center justify-content-center">
          <div class="set-star rating-select">
            <i class="fa fa-star"></i>
          </div>
        </div>
      </template> -->
      <template v-if="column.key === 'name'">
        <div v-if="!renameStates[record.key]" class="d-flex align-item-center">
          <span class="d-inline-block text-truncate" :style="{ maxWidth: '200px' }" :title="record.name">{{ record.name }} </span>
          <span class="ms-2 cursor-pointer" title="Rename" style="font-size: 16px;"
            @click="showRenameField(record.name, record.key)">
            <i class="ti ti-edit"></i></span>
        </div>
        <td class="truncate-doc-name" v-if="renameStates[record.key]">
          <input type="text" class="border-0 border-bottom ms-2" v-model="renameInputs[record.key]">
          <span class="mx-2 cursor-pointer" @click="cancelRename(record.key)">
            <i class="ti-close"></i>
          </span>
          <span v-if="renameInputs[record.key]" class="me-2 cursor-pointer" @click="renameDoc(record.key)">
            <i class="ti ti-check" style="font-size: 18px;"></i>
          </span>
        </td>
      </template>
      <!-- <template v-else-if="column.key === 'Tag'">
        <span :class="record.TagClass">{{ record.Tag }}</span>
      </template> -->
      <!-- <template v-else-if="column.key === 'Rating'">
        <div class="set-star">
          <span><i class="fa fa-star filled"></i> {{ record.Rating }}</span>
        </div>
      </template> -->
      <!-- <template v-else-if="column.key === 'Contact'">
        <ul class="social-links d-flex align-items-center">
          <li>
            <a href="javascript:;"><i class="ti ti-mail"></i></a>
          </li>
          <li>
            <a href="javascript:;"><i class="ti ti-phone"></i></a>
          </li>
          <li>
            <a href="javascript:;"><i class="ti ti-message-circle-share"></i></a>
          </li>
          <li>
            <a href="javascript:;"><i class="ti ti-brand-skype"></i></a>
          </li>
          <li>
            <a href="javascript:;"><i class="ti ti-brand-facebook"></i></a>
          </li>
        </ul>
      </template> -->
      <!-- <template v-else-if="column.key === 'Status'">
        <span :class="record.StatusClass">{{ record.Status }}</span>
      </template> -->
      <template v-else-if="column.key === 'action'">
        <div class="icon-field">
          <router-link :to="{ path: '/crm/report-edit', query: { reportId: record.key, moduleId: record.module_id } }"
            class="btn table_action_btn me-2"><i class="ti ti-edit"></i> Edit</router-link>
          <a class="btn table_action_btn me-2" href="javascript:void(0);" @click="deleteRecord(record.key)"><i
              class="ti ti-trash text-danger"></i> Delete</a>

          <a class="btn table_action_btn me-2" href="javascript:void(0);"
            @click.prevent="reportView(record.key, record?.module_id, record?.dataType, record?.name)">
            <i class="ti ti-eye text-blue-light"></i> Preview</a>

            <a class="btn table_action_btn me-2" href="javascript:void(0);" v-if="['company_admin'].some(role => user.roles.includes(role))"
            @click.prevent="reportShare(record.key)">
            <i class="ti ti-share text-blue-light"></i> Share</a>
        </div>
      </template>
    </template>
  </a-table>
  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>

<reportShareModal :isVisibleShare="isVisibleShare" :refreshId="refresh_id" :reportId="shareReportId" @close="isVisibleShare = false" />

</template>

<script>
import { ref, onMounted, watchEffect, computed } from "vue";
import { useRouter } from "vue-router";
import apiClient from "@/axios";
import { useStore } from "vuex";
import { getCurrentInstance } from "vue";
import moment from "moment";
import reportShareModal from "@/components/modal/report-share-modal.vue";

const columns = [
  {
    title: "Data Type",
    dataIndex: "dataType",
    key: "dataType",
    sorter: {
      compare: (a, b) => {
        a = a.dataType.toLowerCase();
        b = b.dataType.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Updated",
    dataIndex: "updated",
    key: "updated",
    sorter: {
      compare: (a, b) => {
        // Convert the custom date format into a valid date
        const dateA = a.updated
          ? moment(a.updated, "DD/MM/YYYY HH:mm").toDate().getTime()
          : 0;
        const dateB = b.updated
          ? moment(b.updated, "DD/MM/YYYY HH:mm").toDate().getTime()
          : 0;
        return dateA - dateB; // Ascending order
      },
    },
  },

  {
    title: "Action",
    dataIndex: "Action",
    key: "action",
  },
];

export default {
  props: {
    searchQuery: String,
    filters: Object,
  },
  components: {
    reportShareModal,
  },
  data() {
    return {
      columns,
      data: [],
      selectedUserId: null,
      showDeleteModal: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      rowSelection: {
        onChange: () => { },
        onSelect: () => { },
        onSelectAll: () => { },
      },
    };
  },

  setup(props) {
    const router = useRouter();
    const store = useStore();
    const data = ref([]);
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const user = computed(() => store.getters['auth/user']);
    const refresh_id = ref(0)

    const { proxy } = getCurrentInstance();

    const isVisibleShare = ref(false);
    const shareReportId = ref(null);

    const renameStates = ref({})
    const renameInputs = ref({})

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const fetchReports = async (page) => {
      if (typeof page === 'number' && Number.isFinite(page)) {
        pagination.value.current = page;
      }
      try {
        const response = await apiClient.get("/report/list", {
          params: {
            search: props.searchQuery,
            type: props.filters.type,
            name: props.filters.name,
            page: pagination.value.current,
            pageSize: pagination.value.pageSize,
          },
        });
        if (response.data.status) {
          data.value = response.data.data.reports.map((opp) => ({
            key: opp.id,
            name: opp.name,
            dataType: opp.type,
            updated: opp.updated ? formatDate(opp.updated) : null,
            module_id: opp.module_id
          }));
          pagination.value.total = response.data.data.total;
        } else {
          console.error("Failed to fetch opportunities:", response);
        }
      } catch (error) {
        console.error("Error fetching opportunities:", error);
      }
    };
    const handleTableChange = (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchReports();
    };

    const openEditModal = (id, moduleId) => {
      router.push({
        path: "/crm/report-edit",
        query: {
          reportId: id,
          moduleId: moduleId
        },
      });
    };

    const deleteRecord = async (id) => {
      const response = await store.dispatch("report/deleteReportData", id);
      if (response.status) {
        proxy.$toast.open({
          message: response.message,
          type: "success",
          duration: 5000,
        });
        fetchReports();
      } else {
        proxy.$toast.open({
          message: response.message,
          type: "error",
          duration: 5000,
        });
      }

      router.push("/crm/reports-list");
    };

    const reportView = (id, moduleId, dataType, name) => {
      router.push({
        path: "/crm/overview/report",
        query: {
          modN: dataType,
          repN: name,
          reportId: id,
          moduleId: moduleId,
        },
      });
    };

    const reportShare = (id) => {
      isVisibleShare.value = true;
      shareReportId.value = id;
      refresh_id.value++;
    };

    // Function to convert date format
    const formatDate = (dateTime) => {
      if (dateTime) {
        return dateTime.replace(/-/g, '/');
      }
    };

    const showRenameField = (docName, reportId) => {
      renameStates.value[reportId] = true
      renameInputs.value[reportId] = docName
    }

    const cancelRename = (reportId) => {
      renameStates.value[reportId] = false
    }

    const renameDoc = async (reportId) => {
      const newName = renameInputs.value[reportId]
      if (newName) {
        const payload = {
          id: reportId,
          name: newName
        }
        const response = await store.dispatch(
          "report/editReportName",
          payload
        );
        if (response.status) {
          await fetchReports();
          renameStates.value[reportId] = false
        }
      }
    }

    onMounted(() => {
      fetchReports();
    });

    return {
      data,
      formatDate,
      pagination,
      fetchReports,
      handleTableChange,
      openEditModal,
      deleteRecord,
      reportView,
      pageSizeOptions,
      renameStates,
      renameInputs,
      showRenameField,
      cancelRename,
      renameDoc,
      reportShare,
      isVisibleShare,
      shareReportId,
      refresh_id,
      user
    };
  },

  mounted() {
    if (document.getElementsByClassName("edit-popup").length > 0) {
      var addPopups = document.getElementsByClassName("edit-popup");
      for (var i = 0; i < addPopups.length; i++) {
        addPopups[i].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup1")[0];
          if (togglePopup) {
            togglePopup.classList.add("sidebar-popup");
          }
        });
      }

      var sidebarCloses = document.getElementsByClassName("sidebar-close1");
      for (var j = 0; j < sidebarCloses.length; j++) {
        sidebarCloses[j].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup1")[0];
          if (togglePopup) {
            togglePopup.classList.remove("sidebar-popup");
          }
        });
      }
    }
  },
};
</script>
